/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryResponse
 */
export interface CountryResponse {
    /**
     * 
     * @type {string}
     * @memberof CountryResponse
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponse
     */
    label: string;
}

/**
 * Check if a given object implements the CountryResponse interface.
 */
export function instanceOfCountryResponse(value: object): value is CountryResponse {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CountryResponseFromJSON(json: any): CountryResponse {
    return CountryResponseFromJSONTyped(json, false);
}

export function CountryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'label': json['label'],
    };
}

export function CountryResponseToJSON(value?: CountryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'label': value['label'],
    };
}

